// Central Ant Design design-token theme for the admin panel.
// Brand: Edu Action red (#dc281e). Light, modern, minimalist.
const BRAND = '#dc281e';
const BRAND_HOVER = '#e84a41';
const BRAND_ACTIVE = '#b31d15';

const themeConfig = {
    token: {
        colorPrimary: BRAND,
        colorInfo: BRAND,
        colorLink: BRAND,
        colorLinkHover: BRAND_HOVER,

        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        fontSize: 14,

        colorBgLayout: '#f5f6f8',
        colorText: '#1f2430',
        colorTextSecondary: '#5b6472',
        colorBorder: '#e7e9ee',
        colorBorderSecondary: '#eef0f4',

        borderRadius: 8,
        borderRadiusLG: 12,
        borderRadiusSM: 6,

        controlHeight: 38,
        controlHeightLG: 44,

        boxShadow: '0 1px 2px rgba(16, 24, 40, 0.06)',
        boxShadowSecondary: '0 8px 24px rgba(16, 24, 40, 0.08)',

        wireframe: false,
    },
    components: {
        Button: {
            fontWeight: 500,
            primaryShadow: 'none',
            defaultShadow: 'none',
            dangerShadow: 'none',
            controlHeight: 38,
        },
        Menu: {
            itemHeight: 44,
            itemBorderRadius: 8,
            itemMarginInline: 8,
            itemSelectedBg: 'rgba(220, 40, 30, 0.10)',
            itemSelectedColor: BRAND,
            itemActiveBg: 'rgba(220, 40, 30, 0.06)',
            itemHoverBg: 'rgba(16, 24, 40, 0.04)',
            itemColor: '#475160',
            iconSize: 18,
            collapsedIconSize: 20,
            fontSize: 15,
        },
        Table: {
            headerBg: '#f7f8fa',
            headerColor: '#5b6472',
            headerSplitColor: 'transparent',
            borderColor: '#eef0f4',
            rowHoverBg: '#f9fafb',
            cellPaddingBlock: 14,
            cellPaddingInline: 16,
            headerBorderRadius: 12,
        },
        Card: {
            borderRadiusLG: 14,
            boxShadowTertiary: '0 1px 2px rgba(16, 24, 40, 0.06)',
        },
        Input: {
            controlHeight: 38,
            activeShadow: '0 0 0 2px rgba(220, 40, 30, 0.12)',
        },
        Select: {
            controlHeight: 38,
        },
        Drawer: {
            paddingLG: 28,
        },
        Modal: {
            borderRadiusLG: 14,
        },
        Tabs: {
            inkBarColor: BRAND,
            itemSelectedColor: BRAND,
            itemHoverColor: BRAND_HOVER,
            titleFontSize: 14,
        },
        Tag: {
            borderRadiusSM: 6,
        },
    },
};

export { BRAND, BRAND_HOVER, BRAND_ACTIVE };
export default themeConfig;
